<template>
    <div>
        <c-linked-products-end-page
            @change="selectedLinkedProductEndPage(item)"
            class="linked-product-end-page"
            :class="{
                active: !setActiveWhenSelected,
                esgotado: disableWhenOutOfStock || disabledVariationWhenNotSelected
            }"
        >
            <div class="img-linked-product-end-page" style="position: relative;">
                <picture>
                    <source v-if="$productImageSrcset(item.image_main)" type="image/webp" :srcset="$productImageSrcset(item.image_main)" sizes="100px">
                    <img
                        @click="showModalSlider(item.id)"
                        :src="item.image_main"
                        :alt="item.abbreviation"
                        loading="lazy"
                        width="100"
                        height="100"
                    >
                </picture>
            </div>
            <div class="content-linked-product-end-page">
                <template v-if="showQuantity && hidePriceWhenUserIsNotLoggedIn == false && !disabledVariationWhenNotSelected && quantities.length">
                    <select
                        v-model="buyQuantity" size="1"
                        class="form-control form-control-sm quantity-linked-products-end-page"
                        style="padding: 3px 5px; height: auto; margin-bottom: 0;"
                    >
                        <option selected :value="null">Quantidade</option>
                        <option v-for="(i, key) in quantities" :key="key" :value="i">
                            {{ i }}
                        </option>
                    </select>
                </template>
                <template v-if="disableWhenOutOfStock">
                    <span style="color: #d72100; font-size: 14px;">Indisponível</span>
                </template>
                <h2 :title="item.abbreviation">
                    <template v-if="showProductCode">{{ item.api_cod_original }} - </template>
                    {{ item.abbreviation }}
                </h2>
                <template v-if="showPrice && !disableWhenOutOfStock">
                    <span>
                        {{ !item.price_to ? currency.money(item.pro_price_site) : currency.money(item.price_to) }}
                        <small v-if="getShowUnitOfMeasureInProductPrice" style="font-size: 75%;">
                            {{ item.pro_sigla_medida }}
                        </small>
                    </span>
                </template>
                <ProductTellMeWhenYouArrive
                    v-if="disableWhenOutOfStock"
                    :item="item"
                    :link="true"
                />
                <span
                    v-if="item.price_on_request"
                    @click.prevent="consultaWhatsapp()"
                    style="font-size: 1.3rem;"
                >
                    Consultar preço
                </span>
            </div>
        </c-linked-products-end-page>
        <ModalApp :name="'modal_linked_product_end_page_'+item.id" style="overflow-y: auto;">
            <div class="row" style="padding: 10px 20px 20px;">
                <div class="col-12 col-lg-8">
                    <div
                        id="carouselProductsVariation"
                        class="carousel slide"
                        data-ride="carousel"
                        style="width: 100%; margin-top: 10px;"
                        data-interval="10000"
                    >
                        <div class="carousel-inner">
                            <div class="carousel-item active" :id="'carousel-item-'+item.id">
                                <picture>
                                    <source v-if="$productImageSrcset(item.image_main)" type="image/webp" :srcset="$productImageSrcset(item.image_main)" sizes="(max-width: 767px) 90vw, 520px">
                                    <img class="d-block w-100" :src="item.image_main" loading="lazy">
                                </picture>
                            </div>
                            <template v-for="(img, key) in item.images">
                                <div v-if="img.url != item.image_main" :key="key"
                                    class="carousel-item" :id="'carousel-item-'+img.id">
                                    <picture>
                                        <source v-if="$productImageSrcset(img.url)" type="image/webp" :srcset="$productImageSrcset(img.url)" sizes="(max-width: 767px) 90vw, 520px">
                                        <img class="d-block w-100" :src="img.url" loading="lazy">
                                    </picture>
                                </div>
                            </template>
                        </div>
                        <template v-if="item.images.length > 1">
                            <a class="carousel-control-prev" href="#carouselProductsVariation" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Anterior</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselProductsVariation" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Próximo</span>
                            </a>
                        </template>
                    </div>
                </div>
                <div class="col-12 col-lg-4">
                    <ol class="carousel-indicators row"
                        style="position: relative; bottom: 0;
                            justify-content: start;
                            margin: 10px 0px 0px 0px"
                    >
                        <li data-target="#carouselProductsVariation"
                            style="width:80px; height:auto; margin: 0px 10px 10px 0;"
                            class="active"
                            @click="controlsIndicatorsSlider(item.id)"
                        >
                            <picture>
                                <source v-if="$productImageSrcset(item.image_main)" type="image/webp" :srcset="$productImageSrcset(item.image_main)" sizes="80px">
                                <img :src="item.image_main" loading="lazy">
                            </picture>
                        </li>
                        <template v-for="i in item.images">
                            <li :key="i.id"
                                v-if="i.url != item.image_main"
                                data-target="#carouselProductsVariation"
                                style="width:80px; height:auto; margin: 0px 10px 10px 0;"
                                @click="controlsIndicatorsSlider(i.id)"
                            >
                                <picture>
                                    <source v-if="$productImageSrcset(i.url)" type="image/webp" :srcset="$productImageSrcset(i.url)" sizes="80px">
                                    <img :src="i.url" loading="lazy">
                                </picture>
                            </li>
                        </template>
                    </ol>
                </div>
            </div>
        </ModalApp>
    </div>
</template>

<script>
import Currency from '../../helpers/parseCurrency'
import { CLinkedProductsEndPage } from '../Styles/Product/styled'
import ModalApp from '../ModalApp.vue'
import { mapGetters, mapState } from 'vuex'
import ProductTellMeWhenYouArrive from './ProductTellMeWhenYoyArrive'

export default {
    name: 'LinkedProductsEndPage',
    props: {
        item:{type:Object},
        v:{require:true},
        resetProdPage:{default:false},
        reset:{default:false},
        quantitySaleVariations:{default:null}
    },
    components: {
        ModalApp,
        ProductTellMeWhenYouArrive,
        'c-linked-products-end-page': CLinkedProductsEndPage
    },
    data() {
        return {
            currency: Currency,
            buyQuantity: null,
            res: false,
            company: this.$root.$children[0].$attrs.company
        }
    },
    beforeUpdate() {
        this.res = JSON.parse(localStorage.getItem('reset'))
        if(this.res == true) this.buyQuantity = null

        if(this.resetProdPage == true && this.buyQuantity > 0) {
            this.$emit('update:resetProdPage', false)
        }
    },
    methods: {
        consultaWhatsapp() {
            if(!this.textWhatsapp) {
                console.log('Link do whatsapp vazio!')
                return
            }
            window.open(this.textWhatsapp, '_blank');
        },
        selectedLinkedProductEndPage(item) {
            this.$emit('updateLinkedProductEndPage', item, +this.buyQuantity)
        },
        showModalSlider(id) {
            $('#carouselProductsVariation .carousel-item').each(function() {
                $(this).removeClass('active')
            })
            let firstImage = document.getElementById('carousel-item-'+id)
            firstImage.classList.add('active')
            this.$root.showModalApp('modal_linked_product_end_page_'+id)
        },
        controlsIndicatorsSlider(id) {
            $('#carouselProductsVariation .carousel-item').each(function() {
                $(this).removeClass('active')
            })
            let imgSlider = document.getElementById('carousel-item-'+id)
            imgSlider.classList.add('active')
        }
    },
    watch:{
        buyQuantity(val){
            if (!val || val == 0) return
            this.res = false
            localStorage.setItem('reset', 'false')
        },
        resetProdPage(val) {
            if(val == true)
                this.buyQuantity = null
        }
    },
    computed: {
        ...mapState("company", [
            "socials"
        ]),
        ...mapGetters("company", [
            "getShowUnitOfMeasureInProductPrice"
        ]),
        ...mapState("cart", [
            "disabledVariation"
        ]),
        ...mapState("products", [
            "quantityProductItemsGroup"
        ]),
        textWhatsapp() {
            if(!this.socials[4]?.link) {
                return null
            }
            let text = "Olá, tenho interesse no produto "+this.item.pro_name_site+"."
            return this.socials[4].link+"&text="+text
        },
        minQuantity() {
            return this.item.quantity_conversion_factor > this.item.minimum_sale_quantity ? this.item.quantity_conversion_factor : this.item.minimum_sale_quantity
        },
        maxQuantity() {
            let max = this.item.maximum_sale_quantity && this.item.maximum_sale_quantity < this.item.pro_stock_site ?
                (this.item.maximum_sale_quantity ?? this.item.pro_stock_site) :
                (!this.item.pro_stock_site || this.item.pro_stock_site < 1 ? 100 : this.item.pro_stock_site)

            let maxQuantities = [max]
            if(this.item.sell_out_of_stock) {
                max = this.minQuantity > 100 ? this.minQuantity : 100
                maxQuantities.push(max)
            }
            if(this.validateProductGroup) {
                maxQuantities.push(this.quantitySaleVariations)
                maxQuantities.push(this.item.maximum_sale_quantity_variation ?? max)
            }
            if(this.validateProductGroup && this.quantityProductItemsGroup != 0) {
                if(this.setActiveWhenSelected) {
                    maxQuantities.push(this.quantityProductItemsGroup)
                }
            }

            return Math.min(...maxQuantities)
        },
        setActiveWhenSelected() {
            return (!this.buyQuantity || +this.buyQuantity < 1)
        },
        quantities() {
            let qtd = []
            let count = this.minQuantity
            let max = this.item.sell_out_of_stock ? (parseInt(this.maxQuantity) * 1000) : parseInt(this.maxQuantity)
            if(this.validateProductGroup && this.item.sell_out_of_stock) {
                max = parseInt(this.maxQuantity)
            }
            for (let i = this.minQuantity, j = 0; i <= max && j < 100; i = count, j++) {
                let resto = i % Number(this.item.quantity_conversion_factor)
                let qtdFalta = Number(this.item.quantity_conversion_factor) - resto
                count = qtdFalta + i
                qtd.push(i)
            }
            return qtd
        },
        hidePriceWhenUserIsNotLoggedIn() {
            let hide = this.company?.settings?.hide_price_not_logged_user ?? false
            return ( hide === false ) ? false : ( hide === true && this.isLoggedUser === false ? true : false )
        },
        isLoggedUser() {
            return this.$root.$children[0].$attrs.logged
        },
        showPrice() {
            let finalizationOfPayment = this.company.finalizacao_pagamento
            return (
                !this.item.price_on_request &&
                ((finalizationOfPayment.tipo == 'PAGAMENTO' && !this.hidePriceWhenUserIsNotLoggedIn) ||
                (finalizationOfPayment.mostrar_preco && finalizationOfPayment.tipo == 'ORCAMENTO')) &&
                !this.validateProductGroup
            )
        },
        validateProductGroup() {
            return (this.activateSaleProductGroups && this.isProductGroup)
        },
        isProductGroup() {
            return this.item?.is_product_group ?? false
        },
        activateSaleProductGroups() {
            return this.company?.settings?.activate_sale_product_groups ?? false
        },
        disableWhenOutOfStock() {
            return ((this.item.pro_stock_site < 1 || this.item.minimum_sale_quantity > this.item.pro_stock_site) && !this.item.sell_out_of_stock)
        },
        showQuantity() {
            return ((this.item.pro_stock_site > 0 && this.item.minimum_sale_quantity <= this.item.pro_stock_site) || this.item.sell_out_of_stock)
        },
        disabledVariationWhenNotSelected() {
            return this.disabledVariation && (!this.buyQuantity || +this.buyQuantity < 1)
        },
        productsSettings() {
            return this.$root.$children[0].$attrs.company?.products_settings ?? null
        },
        showProductCode() {
            return (this.productsSettings.show_code_original_beside_description ?? false) && this.item.api_cod_original
        }
    }
}
</script>

<style scoped>
.carousel-control-next,
.carousel-control-prev {
    filter: invert(100%);
}
</style>
